import { render, staticRenderFns } from "./VathosAxiosImage.vue?vue&type=template&id=63b1ecfe&lang=pug"
import script from "./VathosAxiosImage.vue?vue&type=script&lang=js"
export * from "./VathosAxiosImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports